import Vue from "vue";
import {
  Icon,
  Skeleton,
  CountDown,
  Empty,
  Button
} from "vant";

Vue.use(Icon);
Vue.use(Skeleton);
Vue.use(CountDown);
Vue.use(Empty);
Vue.use(Button);
